import React, {useEffect, useRef, useState} from 'react';
import gsap, {TweenLite} from 'gsap';
import "./ModalPopUp.sass";
import renderHTML from 'react-render-html';
import StandardButton from "../Button/StandardButton";

const ModalPopUp = ({data,onHide}) => {
    const [showing, setShowing] = useState(true);
    const [hidden,setHidden]=useState(false);
    const popup = useRef(null);

   useEffect(() => {
        console.log("useEffect:" + showing)
       TweenLite.killTweensOf(".ModalPopUp");
        if (!showing) {
            TweenLite.fromTo(".ModalPopUp",1, {opacity:1}, {opacity: 0, onComplete: onHideComplete})
        } else {
            //gsap.quickSetter(".ModalPopUp","opacity","0");
            TweenLite.fromTo(".ModalPopUp", 1,{opacity:0}, {opacity: 1})
        }
    }, [showing]);

    const onHideComplete = () => {

        if(onHide)
        {
            onHide();
        }
    }

    const hide = () => {
        setShowing(showing ? false : true);
    }

    return (
        <div className="ModalPopUp" ref={popup}>
            <div className="panel">
                {data.title?(
                    <div className="panel-title">
                        {data.title}
                        {data.body?(
                            <div className="divider"/>
                        ):null}
                    </div>
                ):null}

                <div className="panel-body">
                    {renderHTML(data.body)}
                </div>

                <StandardButton data={"CONTINUE"} callback={hide} disabled={false}/>
            </div>
            <div className="scrim"/>
        </div>
    );
};

export default ModalPopUp;